
import LEVELS from '@generio-ai/library-legacy/constants/levels'
import ROUTES from '@generio-ai/library-legacy/constants/routes'
import { Card } from '@/classes/card.js'
import { Prompt } from '@/classes/prompt.js'
import { Task } from '@/classes/task.js'
import VERSION from '@/constants/version.js'
import { requires } from '@/utils/validate.js'


export default {

    async openAsset({ commit, getters, dispatch, rootGetters }, {
        asset
    }) {
        // ensure required parameters are present
        requires(asset)

        // get version and try upgrading if necessary
        const version = asset.additional?.version || 1
        if (version !== VERSION) {
            dispatch('notifications/show', {
                message: 'Asset is outdated and upgrade will be supported soon.',
                level: LEVELS.WARNING
            }, { root: true })
            dispatch('overlay/hide', undefined, { root: true })
            return
            //await dispatch('upgradeAsset', { asset })
        }

        // get app and verify if it is registered
        const app = asset.app
        if (!getters.isRegistered(app)) {
            throw new Error(`App '${app}' is not registered in flows store.`)
        }

        // get category and inform about loading
        const category = asset.additional?.category
        dispatch('overlay/show', {
            message: 'loading ' + category
        }, { root: true })

        // create empty new flow to discard any previous state
        commit('NEW_FLOW', {
            app
        })

        // route to app
        const route = Object.values(ROUTES.APPSUITE).find(route => route.app === app)
        if (route === null || route === undefined) {
            throw new Error(`App '${app}' has no valid path.`)
        }
        await dispatch('router/openRoute', { 
            route 
        }, { root: true })

        // allow state to be applied
        setTimeout(() => {

            // get flow
            const flowId = asset.additional?.flow

            // store index of card associated with asset
            const index = asset.additional?.card?.index

            // collect all cards
            const cards = []

            // prepare array of assets for loop mechanic
            let assets = [ asset ]

            do {
                // clone assets to avoid reference issues
                const currentAssets = [...assets]

                // get reference to first asset
                const currentAsset = currentAssets[0]

                // create new prompt
                const prompt = Prompt.newPromptFromAsset(currentAsset)

                // create task to load assets of card
                const task = new Task(
                    async (resolve, reject, progress, parentCard) => {
                        progress('loading card')
                        await dispatch('awaitRetrieved', { assets: currentAssets })
                        resolve({ assets: currentAssets })
                    }
                )

                // create new card
                const card = new Card(
                    flowId,
                    currentAsset.additional?.card?.index,
                    currentAsset.additional?.card?.component,
                    currentAsset.additional?.category,
                    prompt,
                    task
                )
                card.option = currentAsset.additional?.card?.option
                card.action = currentAsset.additional?.card?.action
                card.primitive = currentAsset.additional?.primitive
                card.skipped = currentAsset.additional?.skipped
                card.custom = currentAsset.additional?.custom || {}

                // add card to stack
                cards.push(card)

                // placeholder for parent ids and index
                let parentIds = null
                let parentIndex = null

                do {
                    // get parents belonging to the assets
                    parentIds = assets?.[0]?.additional?.parents

                    // avoid circular references
                    if (parentIds && parentIds.includes(assets[0].id)) {
                        dispatch('notifications/show', {
                            message: 'We had trouble opening the flow.',
                            level: LEVELS.ERROR
                        }, { root: true })
                        dispatch('overlay/hide', undefined, { root: true })
                        return
                    }

                    // get all parent assets
                    if (parentIds && parentIds.length > 0) {
                        assets = parentIds.map(parentId => {
                            return rootGetters['assets/getAsset'](parentId)
                        })
                        // avoid empty parents
                        if (assets.some(a => a === null || a === undefined)) {
                            dispatch('notifications/show', {
                                message: 'We had trouble opening the flow.',
                                level: LEVELS.ERROR
                            }, { root: true })
                            dispatch('overlay/hide', undefined, { root: true })
                            return
                        }
                    }
                    else assets = null

                    // set parent index
                    parentIndex = assets?.[0]?.additional?.card?.index

                } while (parentIndex === card.index)

            } while (assets !== null && assets !== undefined && assets.length > 0)

            // last card should not have actions / options selected
            cards[0].option = null
            cards[0].action = null

            // reverse the array
            cards.reverse()

            // open the flow
            commit('OPEN_FLOW', {
                app,
                flowId,
                cards,
                activeIndex: index
            })

            // hide loading
            dispatch('overlay/hide', undefined, { root: true })

        }, 0)
    }
}